// Quotation Signed Stage  Btn related codes goes here

// NPM Imports
import React, { Fragment } from "react";
import { connect } from "react-redux";

import queryString from "query-string";
import { Toastr, Button, Input, Tooltip } from "@revvsales/components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ReactHtmlParser from "react-html-parser";

import PreviewDocument from "../../QuotationTopbar/QuotationTopbarBtns/PreviewDocument";
import ReferralPopup from "../../SettingsWrapper/ReferralPopup";
import { fetchDocRecipientListAction } from "../../../actions/DocumentActions";
import { GlobalUtils, DocumentUtils } from "../../../utils";
import { QuotationActions } from "../../../actions";
// import { USER_ROLES } from "../../../constants/roleList";

import DocToTemplatePopup from "./DocToTemplate/DocToTemplatePopup";
import DocToTemplateBtn from "./DocToTemplate/DocToTemplateBtn";
import QuickReviewIcon from "../../QuickReview/QuickReviewIcon";

import saveDocAsTemplate from "./DocToTemplate/methods";

// Service Imports
import { cloneDocumentService } from "../../../actions/DocumentActions/services";

// Image Imports
import SEND_TO_SOMEONE_PNG from "../../../assets/TT-Send-to-somone.png";
import MAGICLINK_PNG from "../../../assets/TT-Magic-Link.png";
import SNAPLINK_PNG from "../../../assets/TT-Snaplink.png";

// Destructuring
const {
  copyToClipBoard,
  handleApiErrMsg,
  readDataFromLocalStorage,
} = GlobalUtils;
const { snaplinkGeneratedInfo } = DocumentUtils;
const { updateToolPaneData } = QuotationActions;

class QuotationSignedOwnerBtns extends React.Component {
  state = {
    showMenu: false,
    showDocPreview: false,
    showRenamePopup: false,
    showReferralPopup: false,
    templateName: `${this.props.docName} Template`,
    showShareOptions: false,
    showMoreOptions: false,
  };

  componentDidMount() {
    const { search } = window.location;
    const queryParams = queryString.parse(search);
    if (queryParams) {
      const paramKeys = Object.keys(queryParams);
      // If download params is available & has pdf as value
      if (paramKeys.includes("download") && queryParams.download === "pdf") {
        this.props.togglePopUp("download", true);
      }
    }
    this.props.fetchDocRecipientListAction(this.props.docID);
  }

  createExportRef = element => {
    this.exportRef = element;
  };

  createSendRef = element => {
    this.sendRef = element;
  };

  createShareRef = element => {
    this.shareRef = element;
  };

  componentWillMount = () => {
    document.addEventListener("mousedown", this.handleClick, false);
  };

  componentWillUnMount = () => {
    document.removeEventListener("mousedown", this.handleClick, false);
  };

  showMenu = event => {
    event.preventDefault();
    const { showMenu } = this.state;
    if (!showMenu) {
      const objectId = this.props.docObjectId;
      const objectType = "DOC";
      this.props.getPermaLinkData(objectId, objectType);
      this.props.getSnapLinkData(objectId, objectType);
    }
    this.setState({
      showMenu: !showMenu,
      showShareOptions: false,
      showMoreOptions: false,
    });
  };

  showShareOptions = event => {
    event.preventDefault();
    const { showShareOptions } = this.state;
    if (!showShareOptions) {
      const objectId = this.props.docObjectId;
      const objectType = "DOC";
      this.props.getPermaLinkData(objectId, objectType);
      this.props.getSnapLinkData(objectId, objectType);
    }
    this.setState({
      showShareOptions: !showShareOptions,
      showMoreOptions: false,
      showMenu: false,
    });
  };

  showMoreOptions = event => {
    event.preventDefault();
    const { showMoreOptions } = this.state;
    this.setState({
      showMoreOptions: !showMoreOptions,
      showShareOptions: false,
      showMenu: false,
    });
  };

  handleClick = e => {
    if (
      (this.exportRef && this.exportRef.contains(e.target)) ||
      (this.sendRef && this.sendRef.contains(e.target)) ||
      (this.shareRef && this.shareRef.contains(e.target))
    ) {
      return;
    }
    this.setState({
      showMenu: false,
      showShareOptions: false,
      showMoreOptions: false,
    });
    // this.props.updateToolPaneData(false, "");
  };

  _toggleDocPreviewPopUp = () => {
    const documentSectionHTML = document.getElementsByClassName(
      "document-view-main-container",
    )[0];
    QuotationSignedOwnerBtns.documentHTMLData =
      documentSectionHTML && documentSectionHTML.innerHTML.length > 0
        ? documentSectionHTML.innerHTML
        : "";
    this.setState(prevState => ({
      showDocPreview: !prevState.showDocPreview,
      showMenu: false,
    }));
  };

  _handleCopyLink = data => {
    if (copyToClipBoard(data)) {
      Toastr.showToastr({
        type: "success",
        message: "Copied Successfully",
        timeout: 3000,
      });
    } else {
      Toastr.showToastr({
        type: "failure",
        message: "Error while copying!...",
        timeout: 3000,
      });
    }
  };

  _handleOptionList = value => {
    if (value === "reviewer") {
      this.props.togglePopUp("showAddRecipientsPopup", true, "forReviewer");
      this.setState({ showMenu: false });
    } else if (value === "reffer") {
      this._toggleNavbarPopup("showReferralPopup", true);
      this.setState({ showMoreOptions: false });
    } else if (value === "invite") {
      this.props.togglePopUp("showTeammatePopup", true);
      this.setState({ showMoreOptions: false });
    } else if (value === "metalense") {
      this.setState({ showMoreOptions: false });
      this.props.updateToolPaneData(true, "quick-review");
    }
  };

  _cloneDocument = () => {
    cloneDocumentService(this.props.docID)
      .then(response => {
        const message = "Document successfully cloned";
        Toastr.showToastr({
          type: "failure",
          message,
          timeout: 2000,
        });
        this.setState({
          showMenu: false,
        });
        const currentUrl = this.removeLastDirectoryPartOf(window.location.href);
        window.open(`${currentUrl}/${response.Document.doc_no}`);
      })
      .catch(error => {
        this.setState({
          showMenu: false,
        });
        const message = handleApiErrMsg(error);
        Toastr.showToastr({
          type: "failure",
          message,
          timeout: 2000,
        });
      });
  };

  _toggleNavbarPopup = (type, flag) => {
    this.setState({ [type]: flag });
  };

  handleTemplateName = e => {
    this.setState({
      templateName: e.target.value,
    });
  };

  removeLastDirectoryPartOf = url => {
    const newUrl = url.split("/");
    newUrl.pop();
    return newUrl.join("/");
  };

  toggleDocToTemplatePopup = () => {
    this.setState(prevState => ({
      showRenamePopup: !prevState.showRenamePopup,
    }));
  };

  setStateToInitial = () => {
    this.setState({
      showRenamePopup: false,
      templateName: `${this.props.docName} Template`,
    });
  };

  onSave = () => {
    if (this.state.templateName) {
      saveDocAsTemplate(
        this.props.docID,
        this.state.templateName,
        this.setStateToInitial,
      );
    } else {
      const message = "Template name is required";
      Toastr.showToastr({
        type: "failure",
        message,
        timeout: 2000,
      });
    }
  };

  _downloadDocument = () => {
    if (
      (this.props.isPdfDocument && this.props.document.stage !== "COMPLETED") ||
      (this.props.isPdfDocument &&
        this.props.document.stage === "COMPLETED" &&
        !this.props.isSentForSignature)
    ) {
      window.open(this.props.pdfUrl, "_blank");
      this.setState({ showMoreOptions: false });
    } else {
      this.props.togglePopUp("download", true);
      this.setState({ showMoreOptions: false });
    }
  };

  render() {
    const CURRENT_USER = readDataFromLocalStorage("revvsalesUser");
    const { acceptorsList, sentForSignature } = this.props;
    let popupSpace = null;

    if (this.state.showRenamePopup && !this.props.isPdfDocument) {
      return (
        <DocToTemplatePopup
          togglePopup={this.toggleDocToTemplatePopup}
          handleTemplateName={this.handleTemplateName}
          templateName={this.state.templateName}
          saveDocAsTemplate={this.onSave}
        />
      );
    }
    if (this.state.showRenamePopup && this.props.isPdfDocument) {
      Toastr.showToastr({
        type: "warning",
        message: "Only .docx files can be saved as templates.",
        timeout: 3000,
      });
      this.setState({
        showRenamePopup: false,
      });
    }
    if (this.state.showReferralPopup) {
      popupSpace = <ReferralPopup closePopup={this._toggleNavbarPopup} />;
    }

    return (
      <Fragment>
        {popupSpace}
        {/**
        {popupSpace}
        {CURRENT_USER && CURRENT_USER.roles && CURRENT_USER.roles.length > 0 && (
          <Fragment>
            <div>
              <Tooltip placement="bottom" overlay="Refer and get benefits!">
                <span
                  className="referral-wrapper"
                  onClick={() =>
                    this._toggleNavbarPopup("showReferralPopup", true)
                  }
                  onKeyPress={() => {}}
                  tabIndex="0"
                  role="button">
                  <span aria-label="referral-gift-wrapper" role="img">
                    🎁
                  </span>
                </span>
              </Tooltip>
            </div>
            {CURRENT_USER &&
              CURRENT_USER.roles &&
              CURRENT_USER.roles.length > 0 &&
              CURRENT_USER.roles[0].name === USER_ROLES.ADMIN && (
              <div>
                <Tooltip
                  placement="bottom"
                  overlay="Invite team members to Revv">
                  <span
                    className="user-role-wrapper"
                    onClick={() =>
                      this.props.togglePopUp("showTeammatePopup", true)
                    }
                    onKeyPress={() => {}}
                    tabIndex="0"
                    role="button">
                    <FontAwesomeIcon icon={["fas", "user-plus"]} />
                  </span>
                </Tooltip>
              </div>
              <div className="user-invite-line" />
            </Fragment>
          )}
           */}

        <div>
          <div className="btn-export-wrapper" ref={this.createSendRef}>
            <Tooltip placement="bottom" overlay="Share and send documents">
              <Button
                type="one"
                className="analyse-document"
                data-test="quotation-signed-owner-send-btn"
                onClick={this.showMenu}>
                Send document
                <i
                  className={`ic-dropdown ${
                    this.state.showMenu ? "dropdown-open" : ""
                  }`}>
                  <FontAwesomeIcon
                    icon={["far", "angle-down"]}
                    className="documentrecipientlist-role-icon"
                  />
                </i>
              </Button>
            </Tooltip>
            {this.state.showMenu && (
              <div className="export-dropdown sending-docs">
                <ul className="export-dd-items">
                  <li>
                    <Tooltip
                      placement="left"
                      overlay="Recipients get an email with document link and a request to <b>review and collaborate.</b>"
                      imgUrl={SEND_TO_SOMEONE_PNG}
                      imgAltTxt="send-for-acceptance">
                      <div
                        data-test="cta-send-to-someone-button"
                        className="send-list-item"
                        role="button"
                        tabIndex="0"
                        onClick={() => this._handleOptionList("reviewer")}
                        onKeyPress={() => this._handleOptionList("reviewer")}>
                        <div className="btn-send-icon">
                          <FontAwesomeIcon
                            icon={["far", "paper-plane"]}
                            className="documentrecipientlist-role-icon"
                          />
                        </div>
                        <div>
                          <div className="btn-send-heading">
                            Send to someone
                          </div>
                          <div className="btn-send-desc">
                            {`Send document to recipient's email and give them
                              view or edit access.`}
                          </div>
                        </div>
                      </div>
                    </Tooltip>
                  </li>

                  {/* commenting this now. Wil use in future */}
                  {/* <li>
                  <Tooltip
                    placement="left"
                    overlayClassName="snaplink-tooltip"
                    overlay="Switch it on to take a snapshot of the document. Future changes made on the document, won't get reflected in the shared snap link">
                    
                    <div className="send-list-item" role="button" tabIndex="0">
                      <div className="btn-send-icon">
                        <FontAwesomeIcon
                          icon={["far", "link"]}
                          className="documentrecipientlist-role-icon"
                        />
                      </div>
                      <div>
                        <div className="btn-send-heading">
                          Share a snap link{" "}
                          <span className="save-doc-temp-new-tag">New</span>
                        </div>
                        <div className="btn-send-desc">
                          Copy shareable link with a fixed snapshot of document
                        </div>
                      </div>
                      <div className="btn-share-toggle revv-perma-toggle">
                        <Input
                          data-test="input-revv-inp-checkbox-or-radio"
                          className=" docsharingpopup-sharingform-col"
                          isSwitch
                          type="checkbox"
                          onChange={() =>
                            this.props.checkToggleValue("copySnapLink")
                          }
                          value=""
                          checked={this.props.activeSnapShare}
                        />
                      </div>
                    </div>
                    {this.props.activeSnapShare &&
                      this.props.docSnapLink !== "" && (
                        <div className="permalink-wrapper">
                          <Input
                            ref={this.textInputRef}
                            type="text"
                            id="permaLinkCopy"
                            className="revv-inp"
                            value={this.props.docSnapLink}
                            placeholder="Generating link..."
                            disabled
                          />

                          <div className="copy-btn">
                            <Button
                              className="revv-btn-secondary"
                              onClick={() =>
                                this._handleCopyLink(this.props.docSnapLink)
                              }
                              data-test="quotation-draft-btns-copy">
                              Copy
                            </Button>
                          </div>
                        </div>
                      )}
                  </li>
                  </Tooltip> */}

                  {/* <li>
                    <div
                      className="send-list-item"
                      role="button"
                      tabIndex="0"
                      onClick={this._cloneDocument}
                      onKeyPress={() => {}}>
                      <div className="btn-send-icon">
                        <FontAwesomeIcon
                          icon={["far", "clone"]}
                          className="documentrecipientlist-role-icon"
                        />
                      </div>
                      <div>
                        <div className="btn-send-heading"> Clone document</div>
                        <div className="btn-send-desc">
                          Create a copy and reuse the document as needed
                        </div>
                      </div>
                    </div>
                  </li> */}
                </ul>
              </div>
            )}
          </div>
        </div>
        {/* <Button
          className="analyse-document"
          onClick={() =>
            this.props.togglePopUp(
              "showAddRecipientsPopup",
              true,
              "forReviewer",
            )
          }
          id={"Send for review".replace(/ +/g, "-").toLowerCase()}
          data-test="quotationTopbar-upgrade-stage-btn">
          Share
        </Button> */}
        {/* <Button
          className="revv-btn-secondary"
          onClick={() => this.props.togglePopUp("showShareDocumentPopup", true)}
          id={"Share".replace(/ +/g, "-").toLowerCase()}
          data-test="quotationTopbar-send-for-esignature-btn">
          Share document
        </Button> */}

        <div>
          <div className="btn-export-wrapper" ref={this.createShareRef}>
            <Tooltip placement="bottom" overlay="Share link or publish to web">
              <Button
                className="analyse-document"
                type="one"
                data-test="quotation-draft-btns-share"
                onClick={this.showShareOptions}>
                <FontAwesomeIcon
                  icon={["far", "share-alt"]}
                  className="documentrecipientlist-role-icon"
                />
              </Button>
            </Tooltip>
            {this.state.showShareOptions && (
              <div className="export-dropdown sending-docs">
                <ul className="export-dd-items">
                  <Tooltip
                    placement="left"
                    overlay="Any <b>changes</b> made on the <b>document gets updated</b> on the magic link."
                    imgUrl={MAGICLINK_PNG}
                    imgAltTxt="send-for-acceptance">
                    <li>
                      <div
                        data-test="share-magic-link"
                        className="send-list-item"
                        role="button"
                        tabIndex="0">
                        <div className="btn-send-icon">
                          <FontAwesomeIcon
                            icon={["far", "globe"]}
                            className="documentrecipientlist-role-icon"
                          />
                        </div>
                        <div>
                          <div className="btn-send-heading">
                            Share a magic link
                          </div>
                          <div className="btn-send-desc">
                            Copy shareable link with a live view of document
                          </div>
                        </div>
                        <div className="btn-share-toggle revv-perma-toggle">
                          <Input
                            data-test="input-revv-inp-checkbox-or-radio"
                            className=" docsharingpopup-sharingform-col"
                            isSwitch
                            type="checkbox"
                            onChange={() =>
                              this.props.checkToggleValue("copyLink")
                            }
                            value=""
                            checked={this.props.activeShare}
                          />
                        </div>
                      </div>
                      {this.props.activeShare &&
                        this.props.docPermaLink !== "" && (
                          <div className="permalink-wrapper">
                            <Input
                              ref={this.textInputRef}
                              type="text"
                              id="permaLinkCopy"
                              className="revv-inp"
                              value={this.props.docPermaLink}
                              placeholder="Generating link..."
                              disabled
                            />

                            <div className="copy-btn">
                              <Button
                                className="revv-btn-secondary"
                                onClick={() =>
                                  this._handleCopyLink(this.props.docPermaLink)
                                }
                                data-test="quotation-draft-btns-copy">
                                Copy
                              </Button>
                            </div>
                          </div>
                        )}
                    </li>
                  </Tooltip>
                  {acceptorsList &&
                  acceptorsList.length > 0 &&
                  !sentForSignature &&
                  !this.props.isPdfDocument ? (
                    <Tooltip
                      placement="left"
                      overlay="The <b>snap link</b> will be a <b>timestamped</b> static <b>version</b> of the document."
                      imgUrl={SNAPLINK_PNG}
                      imgAltTxt="send-for-acceptance">
                      <li>
                        <div
                          data-test="share-snap-link"
                          className="send-list-item"
                          role="button"
                          tabIndex="0">
                          <div className="btn-send-icon">
                            <FontAwesomeIcon
                              icon={["far", "link"]}
                              className="documentrecipientlist-role-icon"
                            />
                          </div>
                          <div>
                            <div className="btn-send-heading">
                              Publish a snap link to web
                              <span className="save-doc-temp-new-tag">New</span>
                            </div>
                            <div className="btn-send-desc">
                              Get a search engine friendly link of your document
                              and share it anywhere.
                            </div>
                          </div>
                          <div className="btn-share-toggle revv-perma-toggle">
                            <Input
                              data-test="input-revv-inp-checkbox-or-radio"
                              className=" docsharingpopup-sharingform-col"
                              isSwitch
                              type="checkbox"
                              onChange={() =>
                                this.props.checkToggleValue("copySnapLink")
                              }
                              value=""
                              checked={this.props.activeSnapShare}
                            />
                          </div>
                        </div>
                        {this.props.activeSnapShare &&
                          this.props.docSnapLink !== "" && (
                            <div>
                              <div className="permalink-wrapper">
                                <Input
                                  ref={this.textInputRef}
                                  type="text"
                                  id="permaLinkCopy"
                                  className="revv-inp"
                                  value={this.props.docSnapLink}
                                  placeholder="Generating link..."
                                  disabled
                                />

                                <div className="copy-btn">
                                  <Button
                                    className="revv-btn-secondary"
                                    onClick={() =>
                                      this._handleCopyLink(
                                        this.props.docSnapLink,
                                      )
                                    }
                                    data-test="quotation-draft-btns-copy">
                                    Copy
                                  </Button>
                                </div>
                              </div>
                              <div className="snaplink-generated-info">
                                <span>
                                  {" "}
                                  <FontAwesomeIcon
                                    icon={["far", "info-circle"]}
                                  />
                                </span>
                                <span>
                                  {" "}
                                  {ReactHtmlParser(
                                    snaplinkGeneratedInfo(
                                      this.props.docSnapLinkCreatedAt,
                                    ),
                                  )}
                                </span>
                              </div>
                            </div>
                          )}
                      </li>
                    </Tooltip>
                  ) : null}
                </ul>
              </div>
            )}
          </div>
        </div>

        <div>
          <div className="btn-export-wrapper" ref={this.createExportRef}>
            <Tooltip placement="bottom" overlay="More">
              <Button
                className="analyse-document"
                data-test="quotation-draft-btns-more"
                type="one"
                onClick={this.showMoreOptions}>
                <FontAwesomeIcon
                  icon={["far", "ellipsis-v"]}
                  className="documentrecipientlist-role-icon"
                />
              </Button>
            </Tooltip>
            {this.state.showMoreOptions && (
              <div className="export-dropdown sending-docs">
                <ul className="export-dd-items">
                  <li>
                    <div className="send-list-section-heading">
                      <div className="send-list-section-div">
                        {" "}
                        DOCUMENT ACTIONS
                      </div>
                    </div>
                  </li>
                  <li>
                    <div
                      className="send-list-item"
                      role="button"
                      data-test="download-doc-stage-btn"
                      tabIndex="0"
                      onClick={this._downloadDocument}
                      onKeyPress={this._downloadDocument}>
                      <div className="btn-send-icon">
                        <FontAwesomeIcon
                          icon={["far", "download"]}
                          className="documentrecipientlist-role-icon"
                        />
                      </div>
                      <div>
                        <div className="btn-send-heading">
                          Download document
                        </div>
                        <div className="btn-send-desc">
                          Download a PDF of this document
                        </div>
                      </div>
                    </div>
                  </li>
                  {acceptorsList &&
                  acceptorsList.length > 0 &&
                  !sentForSignature &&
                  !this.props.isPdfDocument ? (
                    <li>
                      <div
                        className="send-list-item"
                        role="button"
                        data-test="cta-preview-document-button"
                        tabIndex="0"
                        onClick={this._toggleDocPreviewPopUp}
                        onKeyPress={() => {}}>
                        <div className="btn-send-icon">
                          <FontAwesomeIcon
                            icon={["far", "eye"]}
                            className="documentrecipientlist-role-icon"
                          />
                        </div>
                        <div>
                          <div className="btn-send-heading">
                            {" "}
                            Preview document
                          </div>
                          <div className="btn-send-desc">
                            See a PDF preview of document
                          </div>
                        </div>
                      </div>
                    </li>
                  ) : null}
                  <li>
                    <div
                      className="send-list-item"
                      role="button"
                      data-test="cta-send-for-metalense-button"
                      tabIndex="0"
                      onClick={() => this._handleOptionList("metalense")}
                      onKeyPress={() => this._handleOptionList("metalense")}>
                      <div className="btn-send-icon">
                        {/* <FontAwesomeIcon
                          icon={["far", "microscope"]}
                          className="documentrecipientlist-role-icon"
                        /> */}
                        <QuickReviewIcon />
                      </div>
                      <div>
                        <div className="btn-send-heading">Enable Metalens</div>
                        <div className="btn-send-desc">
                          Use A.I to analyze document for critical data
                        </div>
                      </div>
                    </div>
                  </li>
                  <li>
                    <div className="send-list-section-heading">
                      <div className="send-list-section-div">
                        {" "}
                        REUSE THIS DOCUMENT
                      </div>
                    </div>
                  </li>
                  {!this.props.isPdfDocument &&
                    CURRENT_USER &&
                    CURRENT_USER.roles &&
                    CURRENT_USER.roles.length > 0 &&
                    CURRENT_USER.roles[0].name === "Admin" && (
                      <DocToTemplateBtn
                        togglePopup={this.toggleDocToTemplatePopup}
                      />
                    )}

                  <li>
                    <div
                      className="send-list-item"
                      role="button"
                      data-test="cta-clone-document-button"
                      tabIndex="0"
                      onClick={this._cloneDocument}
                      onKeyPress={() => {}}>
                      <div className="btn-send-icon">
                        <FontAwesomeIcon
                          icon={["far", "clone"]}
                          className="documentrecipientlist-role-icon"
                        />
                      </div>
                      <div>
                        <div className="btn-send-heading"> Clone document</div>
                        <div className="btn-send-desc">
                          Create a copy and reuse the document as needed
                        </div>
                      </div>
                    </div>
                  </li>

                  <li>
                    <div className="send-list-section-heading">
                      <div className="send-list-section-div">
                        {" "}
                        OTHER ACTIONS
                      </div>
                    </div>
                  </li>
                  <li>
                    <div
                      className="send-list-item"
                      role="button"
                      data-test="cta-send-for-invite-button"
                      tabIndex="0"
                      onClick={() => this._handleOptionList("invite")}
                      onKeyPress={() => this._handleOptionList("invite")}>
                      <div className="btn-send-icon">
                        <FontAwesomeIcon
                          icon={["far", "user-plus"]}
                          className="documentrecipientlist-role-icon"
                        />
                      </div>
                      <div>
                        <div className="btn-send-heading">
                          Invite a teammate to Revv
                        </div>
                        <div className="btn-send-desc">
                          Invite colleagues to join you on Revv and work
                          together
                        </div>
                      </div>
                    </div>
                  </li>
                  <li>
                    <div
                      className="send-list-item"
                      role="button"
                      data-test="cta-send-for-refer-button"
                      tabIndex="0"
                      onClick={() => this._handleOptionList("reffer")}
                      onKeyPress={() => this._handleOptionList("reffer")}>
                      <div className="btn-send-icon">
                        <FontAwesomeIcon
                          icon={["far", "gift"]}
                          className="documentrecipientlist-role-icon"
                        />
                      </div>
                      <div>
                        <div className="btn-send-heading">
                          Refer someone and get benefits
                        </div>
                        <div className="btn-send-desc">
                          Refer businesses, consultants and peers to get Amazon
                          gift cards
                        </div>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            )}
          </div>
        </div>

        {/* <Button
          className="revv-btn-secondary"
          onClick={this._downloadDocument}
          id={"Download".replace(/ +/g, "-").toLowerCase()}
          data-test="download-doc-stage-btn">
          Download
        </Button> */}
        {this.state.showDocPreview && (
          <PreviewDocument
            togglePopUp={this._toggleDocPreviewPopUp}
            html={QuotationSignedOwnerBtns.documentHTMLData}
          />
        )}
      </Fragment>
    );
  }
}

const mapStateToProps = state => {
  const {
    document,
    docRecipientList,
    acceptorsList,
    document: { pdfUrl, is_sent_for_signature: isSentForSignature },
  } = state.DocumentStore;
  return {
    document,
    docRecipientList,
    acceptorsList,
    pdfUrl,
    isSentForSignature,
  };
};
const mapDispatchToProps = {
  fetchDocRecipientListAction,
  updateToolPaneData,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(QuotationSignedOwnerBtns);



// WEBPACK FOOTER //
// ./src/components/QuotationTopBarV2/QuotationTopBarBtns/QuotationSignedOwnerBtns.js